import Offers from '../transportation_requests/offers';
import PriceInput from '../../price_input';
import PriceSuggestion from '../../price_suggestion';
import Slider from '../../slider';

export default class OfferByManager {
	constructor(container, currency_switcher) {
		this.container = container;
		this.form = this.container.querySelector('form');
		this.currency_switcher = currency_switcher;
		this.carrierBlock = this.form.querySelector('.search.carrier');
		this.carrierButton = this.carrierBlock.querySelector('button');
		this.carrierInput = this.carrierBlock.querySelector('input');

		this.addListeners();
	}

	addListeners() {
		this.carrierButton.addEventListener('click', () => this.loadCarrier());
		this.carrierInput.addEventListener('change', () => this.loadCarrier());
	}

	loadCarrier() {
		this.toggleFormControls(true);

		const carrierId = this.carrierInput.value;
		fetch(this.carrierBlock.dataset.action + `?carrier_id=${carrierId}`)
			.then(
				response => {
					if (response.ok) {
						response.text().then(
							text => {
								this.container.innerHTML = text;

								this.initForm();
							}
						);
					} else {
						this.toggleFormControls(false);
					}
				}
			).catch(
				err => {
					this.toggleFormControls(false);
				}
			);
	}

	toggleFormControls(show) {
		this
			.form
			.elements
			.forEach(element => element.toggleAttribute('disabled', show));
	}

	initForm() {
		this.container.querySelectorAll('.cccombo').forEach(element => {
			element.cccombo = new Cccombo(element);
			element.cccombo.init();
		});

		new PriceInput(this.container.querySelector('.price_input'));
		new PriceSuggestion(
			this.container.querySelector('.price_suggestion'),
			this.currency_switcher
		);

		new Slider(this.container.querySelector('.transport_photos_slider'));
		new Offers.Form(this.container);
		new OfferByManager(this.container, this.currency_switcher);
	}
}
